import ModalDialogs from 'vue-modal-dialogs'
import Wizard from '@/helpers/components/display/Wizard'
import Vue from 'vue'
import i18n from '@/providers/i18n'

const Alert = {
  props: ['content'],
  components: {Wizard},
};

// Make an confirmation dialog function
const confirmationrequest = ModalDialogs.makeDialog(
  {
    props: ['title', 'content', 'cancel', 'confirm'],
    components: {Wizard},
    template:
      '<Wizard class="message center" :logo=false> \
        <h3 v-if="title">{{ title }}</h3> \
        <p v-if="content" v-html=content></p> \
        <nav class="actions"> \
          <button class="btn lg" @click="$close(true)">\
            <template v-if="confirm">{{ confirm }}</template>\
            <template v-else>{{ "yes" | trans }}</template>\
          </button> \
          <button class="btn lg inverse" @click="$close(false)">\
            <template v-if="cancel">{{ cancel }}</template>\
            <template v-else>{{ "no" | trans }}</template>\
          </button> \
        </nav> \
      </Wizard>',
    methods: {
      reject () {
        throw new Error('Rejected');
      }
    },
  },
  'title', 'content', 'cancel', 'confirm'
);

// Make an alert dialog function
const alertmessage = ModalDialogs.makeDialog(
  {
    props: {
      content: {},
      state: {},
      wizardclass: {default: 'message center '},
    }['content', 'state', 'wizardclass'],
    components: {Wizard},
    render (el) {
      return el('Wizard', {
        class: this.wizardclass + ' ' + this.state,
        props: {logo: false},
      }, [
        this.htmlcontent(el),
        el('nav', {
          class: 'actions',
        }, [
          el('button', {
            attrs: {type: 'button'},
            class: this.btnclass,
            on: {click: () => this.$close(true)},
          }, [this.$t('buttons.close')]),
        ]),
      ]);
    },
    computed: {
      btnclass () {
        if (this.state === 'closable') {
          return 'close';
        }
        return 'btn lg ' + this.state;
      },
      htmlcontent () {
        return el => {
          if (typeof this.content === 'string') {
            return el('p', {
              domProps: {
                innerHTML: this.content
              },
            });
          } else if (typeof this.content === 'function') {
            return this.content(el);
          }
        }
      },
    },
  },
  'content', 'state', 'wizardclass'
);

// Make a success dialog function
const successmessage = ModalDialogs.makeDialog(
  {
    props: ['content'],
    template:
      '<div><transition name="toast" appear><div class="toast success" @click="$close()"> \
        {{ content }} \
      </div></transition></div>',
    mounted () {
      window.setTimeout(() => this.$close(), 5000);
    },
  },
  'content'
);

var buildmessage = (message) => {
  if (Array.isArray(message) && message.length) {
    if (typeof message[0] === 'string') {
      message = '<p>' + message.filter(m => m.trim()).join('</p><p>') + '</p>';
    }
  }
  return message;
};

document.toast = function (message, status, wizardclass = 'message center') {
  if (['error', 'info', 'closable'].includes(status)) {
    return alertmessage(buildmessage(message), status, wizardclass);
  } else {
    return successmessage(buildmessage(message));
  }
}

document.toastconfirm = function (message, title, cancel, confirm) {
  return confirmationrequest(title, buildmessage(message), cancel, confirm);
}


var promisetoast = function (success = false, error = null) {
  var chain = this;
  if (success === null) {
    success = 'Success!';
  }
  if (error === null) {
    error = 'Error!';
  }
  if (success) {
    chain = chain.then((a) => {document.toast(success, 'success'); return a;});
  }
  if (error) {
    chain = chain.catch((e) => {
      var msg = '';
      if (typeof e === 'string') {
        msg = e;
      } else if (e.hasOwnProperty('message')) {
        msg = e.message;
      }
      return document.toast(error + ' ' + msg, 'error').then(() => {
        throw e;
      })
    });
  }
  return chain;
};

if (!Promise.prototype.toast) {
  Promise.prototype.toast = promisetoast;
}
if (!Promise.toast) {
  Promise.toast = promisetoast;
}

Vue.directive('help', {
  inserted: function (el, binding) {
    var value = binding.value;
    var size = binding.modifiers && binding.modifiers.wizard || 'message center';
    var explanation;
    if (typeof value === 'function') {
      explanation = value;
    } else {
      if (!Array.isArray(value)) {
        value = [value];
      }
      explanation = value.map(v => {
        if (v.indexOf(' ') === -1) {
          return i18n.i18next.t(v);
        }
        return v;
      }).join(' ');
    }
    el.style.cursor = 'help';
    el.addEventListener('click', function (evt) {
      evt.stopPropagation();
      document.toast(explanation, 'info', size);
    });
  },
})


// WEBPACK FOOTER //
// ./src/providers/toast.js